import React from 'react'

function UserTile({ userItem }) {
    return (
        <div className="flex flex-col border-slate-200 bg-white shadow-sm my-6 border rounded-lg w-96">
            <div className="flex justify-center items-center m-2.5 rounded-md h-80 overflow-hidden">
                <img className="w-full h-full object-cover" src="https://docs.material-tailwind.com/img/team-3.jpg" alt="profile-picture" />
            </div>
            <div className="p-6 text-center">
                <h4 className="mb-1 font-semibold text-slate-800 text-xl">
                    Natalie Paisley
                </h4>
                <p
                    className="font-semibold text-slate-500 text-sm uppercase">
                    Product Manager
                </p>
                <p className="mt-4 font-light text-base text-slate-600">
                    The place is close to Barceloneta Beach and bus stop just 2 min by walk and near to Naviglio where you can enjoy the main night life in Barcelona.
                </p>
            </div>
            <div className="flex justify-center gap-7 p-6 pt-2">
                <button className="bg-slate-800 hover:bg-slate-700 focus:bg-slate-700 active:bg-slate-700 disabled:opacity-50 shadow-md hover:shadow-lg focus:shadow-none active:shadow-none disabled:shadow-none px-4 py-2 border border-transparent rounded-md min-w-32 text-center text-sm text-white transition-all disabled:pointer-events-none" type="button">
                    Follow
                </button>
            </div>
        </div>
    )
}

export default UserTile